import React, { ButtonHTMLAttributes, DetailedHTMLProps, ReactNode } from "react";

export function SavingButton({children, icon = null, saving = false, ...rest}:{children:ReactNode, saving?:boolean, icon?:string} & DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>){
    return <button className="btn btn-primary" {...rest}>
            <>
                {(!saving && icon) && <i className={`fa ${icon} me-2`}></i>}
                {saving && <i className="fa fa-spin fa-circle-notch me-2"></i>}
                {children}
            </>
        </button>
}

export const LoadingButton = SavingButton;